import React, { useState, useEffect, useContext } from "react";
import BuildhubLogoSmall from "../../images/buildhub-small.png";
import buildhubBg from "../../images/bg.png";

function RequestSideBar({ pagePermissions, viewingPage }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);

  const handleSideBarCollapsedClick = () => {
    setSidebarCollapsed((prevState) => !sidebarCollapsed);
  };

  const isActive = (page) => viewingPage === page;

  return (
    <div
      className={`sidebar ${sidebarCollapsed ? "close" : ""}`}
      style={{ backgroundImage: `url(${buildhubBg})` }}
    >
      <div className="logo-details">
        <i
          className="fa fa-bars"
          aria-hidden="true"
          onClick={(e) => handleSideBarCollapsedClick()}
        ></i>
      </div>
      <ul className="nav-links">
        {pagePermissions?.approval_page && (
          <>
            <li className={isActive("view-approval-list") ? "active-menu" : ""}>
              <a href="/requests?p=view-approval-list">
                <i className="fa fa-thumbs-o-up" aria-hidden="true"></i>
                <span className="link_name">Approvals</span>
              </a>
            </li>
          </>
        )}
        {pagePermissions?.approval_page && (
          <>
            <li
              className={isActive("view-approve-history") ? "active-menu" : ""}
            >
              <a href="/requests?p=view-approve-history">
                <i className="fa fa-hourglass-half" aria-hidden="true"></i>
                <span className="link_name">Approver History</span>
              </a>
            </li>
          </>
        )}
        {pagePermissions?.tagging_page && (
          <>
            <li className={isActive("view-for-tagging") ? "active-menu" : ""}>
              <a href="/requests?p=view-for-tagging">
                <i className="fa fa-tag" aria-hidden="true"></i>
                <span className="link_name">For Tagging</span>
              </a>
            </li>
            <li
              className={isActive("view-approval-history") ? "active-menu" : ""}
            >
              <a href="/requests?p=view-approval-history">
                <i className="fa fa-history" aria-hidden="true"></i>
                <span className="link_name">Tagging History</span>
              </a>
            </li>
          </>
        )}
        {pagePermissions?.audit_page && (
          <>
            <li className={isActive("view-reports") ? "active-menu" : ""}>
              <a href="/requests?p=view-reports">
                <i className="fa fa-clipboard" aria-hidden="true"></i>
                <span className="link_name">For Audit</span>
              </a>
            </li>
          </>
        )}
        {pagePermissions?.ccar_page && (
          <li className={isActive("view-ccar") ? "active-menu" : ""}>
            <a href="/requests?p=view-ccar">
              <i className="fa fa-clipboard" aria-hidden="true"></i>
              <span className="link_name">CCAR History</span>
            </a>
          </li>
        )}
        <li className={isActive("view-requests") ? "active-menu" : ""}>
          <a href="/requests?p=view-requests">
            <i className="fa fa-file-text-o" aria-hidden="true"></i>
            <span className="link_name">My Requests</span>
          </a>
        </li>

        <li className={isActive("view-forms") ? "active-menu" : ""}>
          <a href="/requests?p=view-forms">
            <i className="fa fa-list" aria-hidden="true"></i>
            <span className="link_name">My Forms</span>
          </a>
        </li>
      </ul>
    </div>
  );
}

export default RequestSideBar;